import React from 'react';

export const NotifySmiley = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="notify-smiley"
  >
    <rect width="60" height="60" rx="30" fill="#0F8CFF" fillOpacity="0.1" />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="18"
      y="18"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 40.5C35.799 40.5 40.5 35.799 40.5 30C40.5 24.201 35.799 19.5 30 19.5C24.201 19.5 19.5 24.201 19.5 30C19.5 35.799 24.201 40.5 30 40.5ZM30 42C36.6274 42 42 36.6274 42 30C42 23.3726 36.6274 18 30 18C23.3726 18 18 23.3726 18 30C18 36.6274 23.3726 42 30 42Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4272 32.3508C24.7857 32.1434 25.2445 32.2659 25.4519 32.6245C26.3608 34.1956 28.0577 35.25 30 35.25C31.9423 35.25 33.6393 34.1956 34.5481 32.6245C34.7556 32.2659 35.2143 32.1434 35.5729 32.3508C35.9314 32.5582 36.054 33.017 35.8466 33.3755C34.6806 35.3912 32.4994 36.75 30 36.75C27.5006 36.75 25.3195 35.3912 24.1535 33.3755C23.9461 33.017 24.0686 32.5582 24.4272 32.3508Z"
        fill="black"
      />
      <path
        d="M28.5 27.75C28.5 28.9926 27.8284 30 27 30C26.1716 30 25.5 28.9926 25.5 27.75C25.5 26.5074 26.1716 25.5 27 25.5C27.8284 25.5 28.5 26.5074 28.5 27.75Z"
        fill="black"
      />
      <path
        d="M34.5 27.75C34.5 28.9926 33.8284 30 33 30C32.1716 30 31.5 28.9926 31.5 27.75C31.5 26.5074 32.1716 25.5 33 25.5C33.8284 25.5 34.5 26.5074 34.5 27.75Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect x="18" y="18" width="24" height="24" fill="#0F8CFF" />
    </g>
  </svg>
);

export const SuccessSmiley = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="success-smiley"
  >
    <rect width="60" height="60" rx="30" fill="#00E59E" fillOpacity="0.1" />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="18"
      y="18"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 40.5C35.799 40.5 40.5 35.799 40.5 30C40.5 24.201 35.799 19.5 30 19.5C24.201 19.5 19.5 24.201 19.5 30C19.5 35.799 24.201 40.5 30 40.5ZM30 42C36.6274 42 42 36.6274 42 30C42 23.3726 36.6274 18 30 18C23.3726 18 18 23.3726 18 30C18 36.6274 23.3726 42 30 42Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4272 32.3508C24.7857 32.1434 25.2445 32.2659 25.4519 32.6245C26.3608 34.1956 28.0577 35.25 30 35.25C31.9423 35.25 33.6393 34.1956 34.5481 32.6245C34.7556 32.2659 35.2143 32.1434 35.5729 32.3508C35.9314 32.5582 36.054 33.017 35.8466 33.3755C34.6806 35.3912 32.4994 36.75 30 36.75C27.5006 36.75 25.3195 35.3912 24.1535 33.3755C23.9461 33.017 24.0686 32.5582 24.4272 32.3508Z"
        fill="black"
      />
      <path
        d="M28.5 27.75C28.5 28.9926 27.8284 30 27 30C26.1716 30 25.5 28.9926 25.5 27.75C25.5 26.5074 26.1716 25.5 27 25.5C27.8284 25.5 28.5 26.5074 28.5 27.75Z"
        fill="black"
      />
      <path
        d="M34.5 27.75C34.5 28.9926 33.8284 30 33 30C32.1716 30 31.5 28.9926 31.5 27.75C31.5 26.5074 32.1716 25.5 33 25.5C33.8284 25.5 34.5 26.5074 34.5 27.75Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect x="18" y="18" width="24" height="24" fill="#32D269" />
    </g>
  </svg>
);

export const ErrorSmiley = () => (
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="error-smiley"
  >
    <rect width="60" height="60" rx="30" fill="#FF5B5B" fillOpacity="0.1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 40.5C35.799 40.5 40.5 35.799 40.5 30C40.5 24.201 35.799 19.5 30 19.5C24.201 19.5 19.5 24.201 19.5 30C19.5 35.799 24.201 40.5 30 40.5ZM30 42C36.6274 42 42 36.6274 42 30C42 23.3726 36.6274 18 30 18C23.3726 18 18 23.3726 18 30C18 36.6274 23.3726 42 30 42Z"
      fill="#FF5B5B"
    />
    <path
      d="M28.5 27.75C28.5 28.9926 27.8284 30 27 30C26.1716 30 25.5 28.9926 25.5 27.75C25.5 26.5074 26.1716 25.5 27 25.5C27.8284 25.5 28.5 26.5074 28.5 27.75Z"
      fill="#FF5B5B"
    />
    <path
      d="M34.5 27.75C34.5 28.9926 33.8284 30 33 30C32.1716 30 31.5 28.9926 31.5 27.75C31.5 26.5074 32.1716 25.5 33 25.5C33.8284 25.5 34.5 26.5074 34.5 27.75Z"
      fill="#FF5B5B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.5729 36.6491C35.2144 36.8565 34.7556 36.734 34.5481 36.3754C33.6393 34.8042 31.9423 33.7499 30 33.7499C28.0578 33.7499 26.3608 34.8042 25.4519 36.3754C25.2445 36.734 24.7857 36.8565 24.4272 36.6491C24.0687 36.4417 23.9461 35.9829 24.1535 35.6243C25.3195 33.6087 27.5007 32.2499 30 32.2499C32.4994 32.2499 34.6806 33.6087 35.8466 35.6243C36.054 35.9829 35.9314 36.4417 35.5729 36.6491Z"
      fill="#FF5B5B"
    />
  </svg>
);
